import styled from 'styled-components'

import { Typography } from '@web-apps/ui-shared'
import { AuthPageWrapper } from '@web-apps/feature-auth'

export const StyledText = styled(Typography)`
  text-align: center;
`

export const StyledWrapper = styled(AuthPageWrapper)`
  background: none;
  margin-block-start: 20px;
`
